"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var services_1 = require("stremio/services");
var common_1 = require("stremio/common");
var LANGUAGES_NAMES = common_1.languageNames;
var usePlayerOptions = function (profile) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, services_1.useServices)().core;
    var platform = (0, common_1.usePlatform)();
    var languageOptions = (0, react_1.useMemo)(function () { return Object.keys(LANGUAGES_NAMES).map(function (code) { return ({
        value: code,
        label: LANGUAGES_NAMES[code]
    }); }); }, []);
    var sortedLanguageOptions = (0, common_1.useLanguageSorting)(languageOptions).sortedOptions;
    var subtitlesLanguageSelect = (0, react_1.useMemo)(function () { return ({
        options: __spreadArray([
            { value: null, label: t('NONE') }
        ], sortedLanguageOptions, true),
        value: profile.settings.subtitlesLanguage,
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { subtitlesLanguage: value })
                }
            });
        }
    }); }, [profile.settings, sortedLanguageOptions]);
    var subtitlesSizeSelect = (0, react_1.useMemo)(function () { return ({
        options: common_1.CONSTANTS.SUBTITLES_SIZES.map(function (size) { return ({
            value: "".concat(size),
            label: "".concat(size, "%")
        }); }),
        value: "".concat(profile.settings.subtitlesSize),
        title: function () {
            return "".concat(profile.settings.subtitlesSize, "%");
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { subtitlesSize: parseInt(value, 10) })
                }
            });
        }
    }); }, [profile.settings]);
    var subtitlesTextColorInput = (0, react_1.useMemo)(function () { return ({
        value: profile.settings.subtitlesTextColor,
        onChange: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { subtitlesTextColor: value })
                }
            });
        }
    }); }, [profile.settings]);
    var subtitlesBackgroundColorInput = (0, react_1.useMemo)(function () { return ({
        value: profile.settings.subtitlesBackgroundColor,
        onChange: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { subtitlesBackgroundColor: value })
                }
            });
        }
    }); }, [profile.settings]);
    var subtitlesOutlineColorInput = (0, react_1.useMemo)(function () { return ({
        value: profile.settings.subtitlesOutlineColor,
        onChange: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { subtitlesOutlineColor: value })
                }
            });
        }
    }); }, [profile.settings]);
    var audioLanguageSelect = (0, react_1.useMemo)(function () { return ({
        options: sortedLanguageOptions,
        value: profile.settings.audioLanguage,
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { audioLanguage: value })
                }
            });
        }
    }); }, [profile.settings, sortedLanguageOptions]);
    var surroundSoundToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.surroundSound,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { surroundSound: !profile.settings.surroundSound })
                }
            });
        }
    }); }, [profile.settings]);
    var seekTimeDurationSelect = (0, react_1.useMemo)(function () { return ({
        options: common_1.CONSTANTS.SEEK_TIME_DURATIONS.map(function (size) { return ({
            value: "".concat(size),
            label: "".concat(size / 1000, " ").concat(t('SECONDS'))
        }); }),
        value: "".concat(profile.settings.seekTimeDuration),
        title: function () {
            return "".concat(profile.settings.seekTimeDuration / 1000, " ").concat(t('SECONDS'));
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { seekTimeDuration: parseInt(value, 10) })
                }
            });
        }
    }); }, [profile.settings]);
    var seekShortTimeDurationSelect = (0, react_1.useMemo)(function () { return ({
        options: common_1.CONSTANTS.SEEK_TIME_DURATIONS.map(function (size) { return ({
            value: "".concat(size),
            label: "".concat(size / 1000, " ").concat(t('SECONDS'))
        }); }),
        value: "".concat(profile.settings.seekShortTimeDuration),
        title: function () {
            return "".concat(profile.settings.seekShortTimeDuration / 1000, " ").concat(t('SECONDS'));
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { seekShortTimeDuration: parseInt(value, 10) })
                }
            });
        }
    }); }, [profile.settings]);
    var playInExternalPlayerSelect = (0, react_1.useMemo)(function () { return ({
        options: common_1.CONSTANTS.EXTERNAL_PLAYERS
            .filter(function (_a) {
            var platforms = _a.platforms;
            return platforms.includes(platform.name);
        })
            .map(function (_a) {
            var label = _a.label, value = _a.value;
            return ({
                value: value,
                label: t(label),
            });
        }),
        value: profile.settings.playerType,
        title: function () {
            var selectedOption = common_1.CONSTANTS.EXTERNAL_PLAYERS.find(function (_a) {
                var value = _a.value;
                return value === profile.settings.playerType;
            });
            return selectedOption ? t(selectedOption.label, { defaultValue: selectedOption.label }) : profile.settings.playerType;
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { playerType: value })
                }
            });
        }
    }); }, [profile.settings]);
    var nextVideoPopupDurationSelect = (0, react_1.useMemo)(function () { return ({
        options: common_1.CONSTANTS.NEXT_VIDEO_POPUP_DURATIONS.map(function (duration) { return ({
            value: "".concat(duration),
            label: duration === 0 ? 'Disabled' : "".concat(duration / 1000, " ").concat(t('SECONDS'))
        }); }),
        value: "".concat(profile.settings.nextVideoNotificationDuration),
        title: function () {
            return profile.settings.nextVideoNotificationDuration === 0 ?
                'Disabled'
                :
                    "".concat(profile.settings.nextVideoNotificationDuration / 1000, " ").concat(t('SECONDS'));
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { nextVideoNotificationDuration: parseInt(value, 10) })
                }
            });
        }
    }); }, [profile.settings]);
    var bingeWatchingToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.bingeWatching,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { bingeWatching: !profile.settings.bingeWatching })
                }
            });
        }
    }); }, [profile.settings]);
    var playInBackgroundToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.playInBackground,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { playInBackground: !profile.settings.playInBackground })
                }
            });
        }
    }); }, [profile.settings]);
    var hardwareDecodingToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.hardwareDecoding,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { hardwareDecoding: !profile.settings.hardwareDecoding })
                }
            });
        }
    }); }, [profile.settings]);
    var videoModeSelect = (0, react_1.useMemo)(function () { return ({
        options: [
            {
                value: null,
                label: t('SETTINGS_VIDEO_MODE_DEFAULT'),
            },
            {
                value: 'legacy',
                label: t('SETTINGS_VIDEO_MODE_LEGACY'),
            }
        ],
        value: profile.settings.videoMode,
        title: function () {
            return profile.settings.videoMode === 'legacy' ?
                t('SETTINGS_VIDEO_MODE_LEGACY')
                :
                    t('SETTINGS_VIDEO_MODE_DEFAULT');
        },
        onSelect: function (value) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { videoMode: value })
                }
            });
        }
    }); }, [profile.settings]);
    var pauseOnMinimizeToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.pauseOnMinimize,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { pauseOnMinimize: !profile.settings.pauseOnMinimize })
                }
            });
        }
    }); }, [profile.settings]);
    return {
        subtitlesLanguageSelect: subtitlesLanguageSelect,
        subtitlesSizeSelect: subtitlesSizeSelect,
        subtitlesTextColorInput: subtitlesTextColorInput,
        subtitlesBackgroundColorInput: subtitlesBackgroundColorInput,
        subtitlesOutlineColorInput: subtitlesOutlineColorInput,
        audioLanguageSelect: audioLanguageSelect,
        surroundSoundToggle: surroundSoundToggle,
        seekTimeDurationSelect: seekTimeDurationSelect,
        seekShortTimeDurationSelect: seekShortTimeDurationSelect,
        playInExternalPlayerSelect: playInExternalPlayerSelect,
        nextVideoPopupDurationSelect: nextVideoPopupDurationSelect,
        bingeWatchingToggle: bingeWatchingToggle,
        playInBackgroundToggle: playInBackgroundToggle,
        hardwareDecodingToggle: hardwareDecodingToggle,
        videoModeSelect: videoModeSelect,
        pauseOnMinimizeToggle: pauseOnMinimizeToggle,
    };
};
exports.default = usePlayerOptions;
